// Used when the API has no settings yet; mirrors palma-bay-motos-front/src/info/store.json
const defaultSettings = {
  place: {
    stret: "Carrer Francesc Sancho, 24",
    city: "07004 Palma",
    country: "Illes Balears, España",
    lat: "39.579702",
    lng: "2.655273"
  },
  scheduleMinMax: [9, 19],
  seasons: {
    summer: {
      start: "05-01 00:00",
      scheduleLight: { es: "9:00 - 19:00", en: "9:00 AM - 7:00 PM" },
      schedule: [
        {
          es: "De Lunes a Domingo de 9:00 a 19:00 (24h Solo Reservas Online)",
          en: "Monday To Sunday from 9:00 AM to 7:00 PM. (24h Only online Booking)"
        },
        { es: "", en: "" }
      ]
    },
    winter: {
      start: "10-01 00:00",
      scheduleLight: { es: "9:00 - 17:00", en: "9:00 AM - 5:00 PM" },
      schedule: [
        {
          es: "De Lunes a Viernes de 9:00 a 17:00 (24h Solo Reservas Online)",
          en: "Monday To Friday from 9:00 AM to 5:00 PM. (24h Only online Booking)"
        },
        { es: "Sábado y Domingo cerrado", en: "Saturday and Sunday closed" }
      ]
    }
  },
  phone: "+34 871 536 631",
  whatsapp: "+34 698 535 071",
  email: "info@palmabayvesparental.com",
  emailTemp: "palmabayvesparental@gmail.com"
};

export default defaultSettings;
